import { getAllPipeline } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

export default function usePipeline(
  callBack?: (data: any) => void,
  branchId?: number | string | null,
  enabled: boolean = true,
) {
  // Branch-based pipelines: an optional branchId scopes the pipeline to that
  // branch's fork (board/forked-branch contexts). Omitted (the 40+ existing
  // consumers) → tenant-wide default, byte-identical cache key. `enabled` lets a
  // caller keep this query dormant until it's actually needed (e.g. only fetch a
  // fork's stages once a forked branch is chosen) — default true preserves every
  // existing consumer's behavior exactly.
  const scoped = branchId != null && branchId !== "";
  const query = useQuery({
    queryKey: scoped ? ["pipeline-stage", String(branchId)] : ["pipeline-stage"],
    enabled,
    queryFn: async () => {
      const res = await axiosInstance.get(
        getAllPipeline,
        scoped ? { params: { branchId } } : undefined,
      );
      return res.data?.stages ?? res.data?.pipeline ?? [];
    },
  });

  useEffect(() => {
    if (query.data && callBack) {
      callBack(query.data);
    }
  }, [query.data]);

  return {
    pipeline: query.data,
    statusOptions: query?.data?.map((val: any) => ({
      value: val.id,
      label: val.name,
    })),
    length: query.data ? query.data.length : 0,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
